module.exports = __webpack_public_path__ + "img/20.54d232a2.png";